exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-buttons.flex-container {\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  margin: unset;\n  margin: none; }\n  .panel-buttons.flex-container a i.fa-close {\n    font-size: 1.2em; }\n\n.detail-header-section {\n  padding-top: 0; }\n\n@media (min-width: 320px) and (max-width: 480px) {\n  .block {\n    padding: 5px !important; }\n  .section.detail-header-section .flex-container {\n    margin: unset !important; }\n    .section.detail-header-section .flex-container .flex-item {\n      width: unset !important; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/route-info-panel.component.scss
// module id = ../../../../../src/app/common/route-info-panel.component.scss
// module chunks = main